<template>
  <section class="testimonials">
    <h1>{{ $t('reviews.title')}}</h1>
 
    <div class="reviews-wrapper">
    <!-- Flèche gauche -->
    <button class="nav left" @click="prevPage" :disabled="!canPrev">←</button>

    <div class="reviews">
      <div class="review-card" v-for="(review, index) in visibleReviews" :key="index">
        <p class="review-text">{{ review.text }}</p>

        <div class="review-footer">
          <div class="author-info">
            <p class="author">{{ review.author }}</p>
            <p class="platform">{{ review.platform }}</p>
          </div>

          <div class="rating">
            <span v-for="n in 5" :key="n">
              <svg v-if="n <= review.rating" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                <path d="M10 15l-5.878 3.09L5.64 12.18.764 8.41l6.182-.9L10 2l3.054 5.51 6.182.9-4.877 3.77 1.518 5.91z" />
              </svg>
              <svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="lightgray">
                <path d="M10 15l-5.878 3.09L5.64 12.18.764 8.41l6.182-.9L10 2l3.054 5.51 6.182.9-4.877 3.77 1.518 5.91z" />
              </svg>
            </span>
          </div>
        </div>
        </div>
      </div>
           <button class="nav right" @click="nextPage" :disabled="!canNext">→</button>
    </div>

  </section>
</template>

<script>
export default {
  name: 'OpinionReview',
  props: {
    reviews: {
      type: Array,
      required: true,
       default: () => [],
    },
  },
    data() {
    return {
      currentPage: 0,
      perPage: 3,
    };
  },
   computed: {
    visibleReviews() {
      const start = this.currentPage * this.perPage;
      return this.reviews.slice(start, start + this.perPage);
    },
    canNext() {
      return (this.currentPage + 1) * this.perPage < this.reviews.length;
    },
    canPrev() {
      return this.currentPage > 0;
    }
  },
  methods: {
    nextPage() {
      if (this.canNext) this.currentPage++;
    },
    prevPage() {
      if (this.canPrev) this.currentPage--;
    }
  }
}
</script>

<style lang="scss" scoped>
.testimonials {
 padding: 2rem 1rem;
  text-align: center;
  background: #f8f9fa;
  border-radius: 1rem;

    .reviews-wrapper {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
  }
 .reviews {
    display: grid;
    grid-template-columns: repeat(3, 1fr); // toujours 3 par page
    gap: 1.5rem;
       width: 100%;

    @media (max-width: 900px) {
      grid-template-columns: 1fr;
    }
  }
    .nav {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    font-size: 2rem;
    padding: 0.5rem;
    padding-bottom: 0;
    padding-top: 0;
    border: none;
    background: white;
    cursor: pointer;
    z-index: 10;
    transition: 0.2s;
    box-shadow:none;

    &:hover:not(:disabled) {
      background: #eee;
    }

    &:disabled {
      opacity: 0.3;
      cursor: default;
    }
  }

  .nav.left {
    left: -1rem; // tu peux ajuster
  }

  .nav.right {
    right: -1rem; // tu peux ajuster
  }

  .review-card {
    background: white;
      padding: 1rem;
    border-radius: 1rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-height: 160px; // s'adapte à la hauteur du contenu
 
  }
    .review-text {
      font-style: italic;
      color: #555;
      font-size: 1em;
    }

    .review-footer {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .author-info {
        .author {
          font-weight: bold;
          color: #222;
                font-size: 0.8em;

        }

        .platform {
          font-size: 0.9rem;
          color: #777;
        }
      }

      .rating {
        display: flex;
        gap: 0.1rem;

        svg {
          width: 20px;
          height: 20px;
          color: #fbbf24; // gold
        }
      }
    }
  }

</style>
